import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import CustomButton, { BtnRadius, BtnSizes, BtnTypes } from "../CustomButton";
import LottieFile from "./LottieFile";

interface Props {
  lottieFileType: LottieFileTypes;
  title: string;
  text: string;
  titleClass?: string;
  textClass?: string;
  button?: {
    content: any;
    onClick: () => void;
    isFullWidth?: boolean;
  } | null;
}

const LottieFileInPage: React.FC<Props> = ({
  lottieFileType,
  title,
  text,
  button = null,
  titleClass = null,
  textClass = null,
}) => {
  return (
    <div className="lottie-box">
      <LottieFile lottieFileType={lottieFileType} />
      <div className={`${titleClass ? titleClass : "lottie-title"}`}>
        {title}
      </div>
      <div className={`${textClass ? textClass : "lottie-text"}`}>{text}</div>
      {button && (
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          fullWidth={button.isFullWidth ?? false}
          onClick={button.onClick}
        >
          {button.content}
        </CustomButton>
      )}
    </div>
  );
};

export default LottieFileInPage;
